import { Button, Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext, useEffect } from 'react';
import {
    postTextRewriteGetSuggestedTechNotes,
    postTextRewriteTechnicianInvoiceNotes_AddUpdate,
    Renault_TechnicianWriteUp_NotesItems
} from '../../../Core/Service/techWriteUp-service';
import { PrimaryButton, SecondaryButton, TextBox } from '../../../Core/FormInput';
import AppContext from '../../../App/AppContext';
import { AppStorage } from '../../../Core/Service/storage-service';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 1200,
        border: '1px solid rgba(0,0,0,0.05)',
        '& .MuiTableCell-root': {
            padding: '5px 7px 5px 0px'
        }
    },
    tbody: {
        padding: '0px !important'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    },
    textError: {
        color: 'white'
    },
    textSucc: {
        color: 'black'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

const SuggestedInvoiceText = ({ jobId, onClose }) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = React.useState(false); // for Get Suggested Invoice Text
    const [submitLoading, setSubmitLoading] = React.useState(false); // for Submit
    const [screenLoading, setScreenLoading] = React.useState(true); // for initial fetchData
    const classes = useStyles();

    const [state, setState] = React.useState({
        cureList: []
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setScreenLoading(true);
                let res = await Renault_TechnicianWriteUp_NotesItems(jobId);
                if (res.success) {
                    setState((prevState) => ({ ...prevState, cureList: res.data.list || [] }));
                } else {
                    // Handle API error message
                    showToast(res.message || 'Failed to load technician notes');
                }
            } catch (error) {
                console.error('Error fetching technician notes:', error);
                showToast('Something went wrong while loading technician notes');
            } finally {
                setScreenLoading(false);
            }
        };
        fetchData();
    }, [jobId]);

    const handleCheckbox = (index) => {
        let tempList = [...state.cureList];
        tempList[index].isActive = !tempList[index].isActive;
        setState((prevState) => ({ ...prevState, cureList: tempList }));
    };

    const getSuggestedInvoiceText = async () => {
        try {
            setLoading(true);
            let data = state.cureList.filter((item) => item.isActive).map((itm) => itm.cure);
            const res = await postTextRewriteGetSuggestedTechNotes({ Technotes: data });
            if (res.success) {
                let resList = res.data.message;
                let tempList = [...state.cureList];

                tempList.map((item) => {
                    if (item.isActive) {
                        item.isModified = true;
                        item.invoiceNote = resList.shift();
                    }
                    setState((prevState) => ({ ...prevState, cureList: [...tempList] }));
                });
            }
        } catch (error) {
            console.error('Error getting suggested invoice text:', error);
            showToast('Failed to get suggested invoice text');
        } finally {
            setLoading(false);
        }
    };

    const TechnicianInvoiceNotes_AddUpdate = async () => {
        try {
            setSubmitLoading(true);
            let tempList = state.cureList
                .filter((item) => {
                    if (item.isModified) {
                        return item;
                    }
                })
                .map((item) => {
                    return {
                        technicianInvoiceNotesItemID: item.invoiceItemID,
                        technicianInvoiceNotesItemNotesID: item.techItemID,
                        technicianInvoiceNotesItemDiagnosis: item.invoiceNote
                    };
                });

            let res = await postTextRewriteTechnicianInvoiceNotes_AddUpdate({ NotesItems: tempList });

            if (res.success) {
                showToast(res.data.message || 'Submitted successfully');
                onClose();
            }
        } catch (error) {
            console.error('Error updating technician invoice notes:', error);
            showToast('Failed to submit invoice notes');
        } finally {
            setSubmitLoading(false);
        }
    };

    const fieldChange = (e, index) => {
        const { value } = e.target;
        let tempList = [...state.cureList];
        tempList[index].invoiceNote = value;
        tempList[index].isModified = true;
        setState((prevState) => ({ ...prevState, cureList: tempList }));
    };

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(AppStorage.getCanCopyUpperCaseWriteUps() ? value.toUpperCase() : value);
        showToast('Copied!');
    };

    return (
        <>
            {/* Main screen loader */}
            <Backdrop className={classes.backdrop} open={screenLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {!screenLoading && (
                <Grid container justifyContent="flex-end">
                    <Grid item sx={12} md={4} style={{ textAlign: 'right', marginBottom: '10px' }}>
                        <PrimaryButton onClick={getSuggestedInvoiceText} isBtnLoader={loading} disabled={!state.cureList.some((item) => item.isActive)}>
                            Get Suggested Invoice Text
                        </PrimaryButton>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <TableContainer style={{ height: 'calc(100vh - 160px)' }}>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                aria-label="enhanced table"
                                stickyHeader
                                style={{ tableLayout: 'fixed', width: '100%' }}
                            >
                                <TableHead>
                                    <TableRow hover>
                                        <TableCell width="60px" align="center">
                                            Include
                                        </TableCell>
                                        <TableCell width="120px">Technician</TableCell>
                                        <TableCell width="40%">Technician Writeup (Cure) </TableCell>
                                        <TableCell width="60%">Invoice Text</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody className={classes.tbody}>
                                    {state.cureList.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No rows found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        state.cureList.map((row, index) => (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                <TableCell>
                                                    <Checkbox checked={row.isActive || false} onChange={() => handleCheckbox(index)} name="isActive" />
                                                </TableCell>
                                                <TableCell>{row.tech}</TableCell>
                                                <TableCell>
                                                    <Grid container justifyContent="flex-end" alignItems="flex-end">
                                                        {row.cure && (
                                                            <Grid item>
                                                                <FileCopyIcon
                                                                    style={{ fontSize: '15px', cursor: 'pointer' }}
                                                                    onClick={() => copyToClipboard(row.cure)}
                                                                />
                                                            </Grid>
                                                        )}
                                                        <Grid item xs={12}>
                                                            <TextBox multiline rows={3} name="cure" value={row.cure} disabled />
                                                        </Grid>
                                                    </Grid>
                                                    {/* {row.cure} */}
                                                </TableCell>
                                                <TableCell>
                                                    <Grid container justifyContent="flex-end">
                                                        <Grid item>
                                                            {row.invoiceNote ? (
                                                                <FileCopyIcon
                                                                    style={{ fontSize: '15px', cursor: 'pointer' }}
                                                                    onClick={() => copyToClipboard(row.invoiceNote)}
                                                                />
                                                            ) : (
                                                                <>&nbsp;</>
                                                            )}
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextBox
                                                                multiline
                                                                rows={3}
                                                                name="name"
                                                                onChange={(e) => fieldChange(e, index)}
                                                                value={row.invoiceNote}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                        <SecondaryButton
                            fullWidth
                            onClick={TechnicianInvoiceNotes_AddUpdate}
                            isBtnLoader={submitLoading}
                            disabled={submitLoading || !state.cureList.some((item) => item.isModified)}
                        >
                            Save
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </>
    );
};
export default SuggestedInvoiceText;
